import React from "react";


const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <p>
        Your privacy is important to us. This Privacy Policy explains how we
        collect, use, and protect your personal information.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect personal details such as your name, email, phone number,
        and resume when you fill out forms or use our services.
      </p>

      <h2>2. How We Use Information</h2>
      <p>
        We use your information to provide services, improve user experience,
        and communicate updates. We do not sell or rent your personal data.
      </p>

      <h2>3. Data Security</h2>
      <p>
        We implement reasonable security measures to protect your information.
        However, no method of transmission over the internet is 100% secure.
      </p>

      <h2>4. Cookies</h2>
      <p>
        Our website may use cookies to enhance your browsing experience. You can
        disable cookies in your browser settings.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You have the right to access, update, or request deletion of your
        personal information by contacting us.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
